// extracted by mini-css-extract-plugin
module.exports = {"modal":"InputFormat_modal__1osdk","box":"InputFormat_box__2HvaB","closeIcon":"InputFormat_closeIcon__313Kb"};